"use client";
import { useActionState, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { shortSubmit } from "../kontakt/handle-submit";

const ContactSchema = z.object({
  contactDetail: z.string().min(1),
  // tos: z.literal(true)
});

export function FirstContactBox({ sendLeft = false }) {
  // const [state, formAction] = useActionState(shortSubmit, {
  //   errors: {},
  // });
  // const errors = state.errors ?? {};
  // // const [enabled, setEnabled] = useState(false);
  // const [done, setDone] = useState(false);
  // const { handleSubmit, register, control } = useForm<
  //   z.infer<typeof ContactSchema>
  // >({
  //   defaultValues: {
  //     contactDetail: "",
  //   },
  //   resolver: zodResolver(ContactSchema as any),
  // });

  // useEffect(() => {
  //   if (state?.done) {
  //     toast.success(
  //       "Vielen Dank für die Anfrage. Wir werden uns schnellstmöglich melden.",
  //     );
  //     setDone(true);
  //   }
  // }, [state]);
  // const mutate = useMutation("sendQuickContact");

  // if (done) {
  //   return (
  //     <div className="relative w-full rounded-lg border-l-4 border-green-500 bg-white/10 p-6 shadow-xl backdrop-blur-sm transition-all duration-300 ease-in-out">
  //       <div className="flex items-start">
  //         <div className="mr-4 rounded-full bg-green-500/20 p-2">
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             className="h-6 w-6 text-green-400"
  //             fill="none"
  //             viewBox="0 0 24 24"
  //             stroke="currentColor"
  //           >
  //             <path
  //               strokeLinecap="round"
  //               strokeLinejoin="round"
  //               strokeWidth={2}
  //               d="M5 13l4 4L19 7"
  //             />
  //           </svg>
  //         </div>
  //         <div>
  //           <h2 className="mb-2 text-xl font-semibold text-green-400">
  //             Vielen Dank!
  //           </h2>
  //           <p className="leading-relaxed text-gray-300">
  //             Wir haben die Anfrage erhalten und werden uns schnellstmöglich
  //             melden.
  //           </p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 p-8 shadow-2xl">
      {/* <form
        action={formAction}
        className="relative container w-full rounded-lg border-l-4 border-orange-500 bg-white/10 p-6 shadow-xl backdrop-blur-sm"
      >
        <div className="space-y-4 md:flex md:items-center md:gap-5 md:space-y-0">
          <div className="flex-1 space-y-3">
            <h3 className="flex items-center text-lg font-semibold text-white">
              <span className="mr-2.5 rounded-md bg-orange-500/20 p-1.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-orange-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </span>
              Erstberatung anfordern
            </h3>
            <div className="flex w-full flex-col items-center gap-2 md:flex-row">
              <div className="stretch relative w-full">
                <input
                  type="tel"
                  required
                  placeholder="Telefonnummer oder E-Mail-Adresse"
                  {...register("contactDetail")}
                  className="w-full rounded-lg border border-gray-600/50 bg-gray-900/70 px-4 py-3.5 text-sm backdrop-blur-sm transition-all duration-200 placeholder:text-gray-400 focus:border-transparent focus:ring-2 focus:ring-orange-500/50 focus:outline-none"
                />
                {errors.contactDetail && (
                  <p className="mt-1.5 ml-1 flex items-center text-xs font-medium text-red-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-3.5 w-3.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                    Bitte gib eine Kontaktinformation an
                  </p>
                )}
              </div>
              <div className="stretch-0 w-full shrink-0 self-center md:w-auto md:flex-none">
                <button
                  type="submit"
                  className="group flex w-full items-center justify-center rounded-lg bg-gradient-to-r from-orange-600 to-orange-500 px-6 py-3.5 font-medium whitespace-nowrap text-white shadow-lg shadow-orange-600/20 transition-all duration-300 hover:from-orange-500 hover:to-orange-400 md:w-auto"
                >
                  <span>Beratung anfordern</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-4 w-4 transform transition-transform duration-200 group-hover:translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-gray-700/50 pt-4 text-xs text-gray-400">
          <div className="flex items-center rounded-full bg-gray-900/40 px-2.5 py-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mr-1.5 h-3.5 w-3.5 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            <span>Vertraulich</span>
          </div>
          <div className="flex items-center rounded-full bg-gray-900/40 px-2.5 py-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mr-1.5 h-3.5 w-3.5 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>schnelle Antwort</span>
          </div>
          <div className="flex items-center rounded-full bg-gray-900/40 px-2.5 py-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mr-1.5 h-3.5 w-3.5 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>Kostenlos</span>
          </div>
          <div className="ml-auto">
            <a
              href="/datenschutz"
              target="_blank"
              className="text-xs text-gray-500 underline-offset-2 transition-colors hover:text-orange-400 hover:underline"
            >
              Datenschutz
            </a>
          </div>
        </div>
      </form> */}
    </div>
  );
}
